<h1 mat-dialog-title [innerHTML]="data.title"></h1>
<mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false" color="secondary">
    {{ data.cancelButtonLabel || 'NO' | translate }}
  </button>
  <button mat-flat-button [mat-dialog-close]="true" color="primary">
    {{ data.validateButtonLabel || 'YES' | translate }}
  </button>
</mat-dialog-actions>
